class StockService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getPage(params) {
    return this.apiService.get('/api/v1/stocks', params);
  }
}

export default StockService;
